/**
 * Утилиты для работы с конфигурацией доменов
 * Используют централизованную конфигурацию из config/domains.js
 */
import { isDomain, isFeatureEnabled } from '../config/domains';

/**
 * Проверка на узбекский домен
 * @deprecated Используйте isDomain('uzm.fithousse.com')
 */
export const isUzmDomain = () => {
  return isDomain('uzm.fithousse.com');
};

/**
 * Проверка, нужно ли показывать тарифы
 */
export const shouldShowPricing = () => {
  return isFeatureEnabled('pricing');
};

// Экспортируем все функции из domains.js для удобства
export {
  getDomainConfig,
  isFeatureEnabled,
  getBranding,
  getLocale,
  getCurrency,
  getContactInfo,
  getSocialLinks,
  isDomain,
  getCurrentDomain,
} from '../config/domains';
